import { BACKEND_URL_PREFIX } from '../utils/const';
import { buildDefaultHeaders } from './helper';
import {
  BOOKS_REQUEST_FETCH_STARTED,
  BOOKS_REQUEST_FETCH_COMPLETED,
  BOOKS_REQUEST_ID_COMPLETED,
  SEARCH_BOOKS_STARTED,
  ADD_BOOK_TO_ORDER,
  NEW_ORDER_REQUEST_STARTED,
  NEW_ORDER_REQUEST_COMPLETED,
  NEW_ORDER_REQUEST_ERROR, SEARCH_BOOKS, SUCCESS, ERROR,
} from './types';

export const booksRequestsTable = (dates) =>
  async (dispatch, getState) => {
    dispatch({ type: BOOKS_REQUEST_FETCH_STARTED });
    let datesString = '';
    if (dates) {
      datesString = `?from=${dates[0]}&to=${dates[1]}`;
    }
    const url = `${BACKEND_URL_PREFIX}/library/bookrequest${datesString}`;
    const response = await fetch(`${url}`, buildDefaultHeaders(getState));
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: BOOKS_REQUEST_FETCH_COMPLETED, data: result });
    }
  };


export const booksRequestId = (id) =>
  async (dispatch, getState) => {
    const url = `${BACKEND_URL_PREFIX}/library/bookrequest/${id}`;
    const response = await fetch(`${url}`, buildDefaultHeaders(getState));
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: BOOKS_REQUEST_ID_COMPLETED, data: result });
    }
  };

export const deleteRequestId = (id) =>
  async (dispatch, getState) => {
    const url = `${BACKEND_URL_PREFIX}/library/bookrequest/${id}`;
    const response = await fetch(`${url}`, {
      method: 'DELETE',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Basic ${btoa(`${getState().auth.token}:empty`)}`,
      },
    });
    if (response.ok) {
      const data = await response;
      const { success } = data;
      success && dispatch(booksRequestId(id));
    }
  };

export const addRequest = dataset =>
  async (dispatch, getState) => {
    dispatch({ type: NEW_ORDER_REQUEST_STARTED });
    const url = `${BACKEND_URL_PREFIX}/library/bookrequest`;
    const response = await fetch(`${url}`, {
      method: 'POST',
      body: JSON.stringify(dataset),
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: NEW_ORDER_REQUEST_COMPLETED, data: result });
    } else {
      dispatch({ type: NEW_ORDER_REQUEST_ERROR });
    }
  };

export const searchBooks = (dataset, page) =>
  async (dispatch, getState) => {
    dispatch({ type: SEARCH_BOOKS_STARTED });
    const pageNum = page || 0;
    const url = `${BACKEND_URL_PREFIX}/library/search?maxResults=15&paginateFrom=${pageNum}`;
    const response = await fetch(`${url}`, {
      method: 'POST',
      body: JSON.stringify(dataset),
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const result = await response.json();
      dispatch({ type: `${SEARCH_BOOKS}${SUCCESS}`, data: result });
    } else {
      const result = 'Error';
      dispatch({ type: `${SEARCH_BOOKS}${ERROR}`, data: {error: result} });
    }
  };

export const addBooksToOrder = (dataset, orderId) =>
  async (dispatch, getState) => {
    const url = `${BACKEND_URL_PREFIX}/library/bookrequestbook/${orderId}`;
    const response = await fetch(`${url}`, {
      method: 'POST',
      body: JSON.stringify(dataset),
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const result = await response.json();
      if (result.error) {
        throw new Error('The book you add is already exists in order');
      } else {
        dispatch({ type: ADD_BOOK_TO_ORDER, data: result });
      }
    }
  };

export const removeBooksFromOrder = (requestId) =>
  async (dispatch, getState) => {
    const url = `${BACKEND_URL_PREFIX}/library/bookrequestbook/${requestId}`;
    const response = await fetch(`${url}`, {
      method: 'DELETE',
      headers: {
        'Access-Control-Allow-Origin': '*',
        Authorization: `Basic ${btoa(`${getState().auth.token}:empty`)}`,
      },
    });
    if (response.ok) {
      const data = await response;
      const { success } = data;
      success && dispatch(removeBooksFromOrder(requestId));
    }
  };

export const editBooksFromOrder = (requestId, values) =>
  async (dispatch, getState) => {
    const url = `${BACKEND_URL_PREFIX}/library/bookrequestbook/${requestId}`;
    const response = await fetch(`${url}`, {
      method: 'PUT',
      body: JSON.stringify(values),
      ...buildDefaultHeaders(getState),
    });
    if (response.ok) {
      const data = await response.json();
      data && dispatch(booksRequestsTable());
    }
  };
